import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import FullScreenModal from '@components/modal/fullscreen-modal';
import PhotoGallery from '@components/photo-gallery/component';

const PropertyImagesModal = ({
  property,
  modalIsOpen,
  pageHasChat,
  sharingServicesCollection,
  canonicalUrl
}) => {
  const router = useRouter();

  const onModalClose = () => {
    const currentUrl = router.asPath;
    const urlWithoutQuery = currentUrl.split('?')[0];
    const newQuery = { agentid: router.query.agentid };

    if (router.query.agentid) {
      return router.replace({ pathname: urlWithoutQuery, query: { ...newQuery } }, undefined, {
        shallow: true
      });
    } else {
      return router.replace({ pathname: urlWithoutQuery }, undefined, {
        shallow: true
      });
    }
  };

  return (
    <FullScreenModal
      modalIsOpen={modalIsOpen}
      onModalClose={onModalClose}
      pageHasChat={pageHasChat}
      canonicalUrl={canonicalUrl}
      sharingServicesCollection={sharingServicesCollection}
      property={property}
      content={
        <>
          <PhotoGallery triggerFirstSort={modalIsOpen} images={property.images} />
        </>
      }
    />
  );
};

PropertyImagesModal.propTypes = {
  /**
   * Canonical Url to be displayed and copied onto the clipboard
   */
  canonicalUrl: PropTypes.string,

  /**
   * Specifies whether the modal is currently opened
   */
  modalIsOpen: PropTypes.bool,

  /**
   * Specifies whether the page has a chat button open
   */
  pageHasChat: PropTypes.bool,

  /**
   * Specifies the details of a property
   */
  property: PropTypes.shape({
    address: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        height: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number
      })
    ),
    listingUrl: PropTypes.string,
    status: PropTypes.arrayOf(
      PropTypes.shape({
        newConstruction: PropTypes.bool,
        newListing: PropTypes.bool,
        openHouse: PropTypes.bool,
        pending: PropTypes.bool,
        priceChange: PropTypes.bool
      })
    )
  }),

  /**
   * Function to set whether the modal has been opened
   * Controls whether to push/replace the history object
   * Prevents cascading history on open/close of modal
   */
  setModalHasBeenOpened: PropTypes.func,

  /**
   * Collection of share items to be displayed within the modal
   */
  sharingServicesCollection: PropTypes.arrayOf(
    PropTypes.shape({
      shareName: PropTypes.string,
      shareUrl: PropTypes.string
    })
  )
};

export default PropertyImagesModal;
